'use client';

import { AboutHeroSection } from '@/components/sections/AboutHeroSection';
import { TaglineBannerSection } from '@/components/sections/TaglineBannerSection';
import { AskQuestionSection } from '@/components/sections/AskQuestionSection';
import { ClientsReviewsSectionV2 } from '@/components/sections/ClientsReviewsSectionV2';
import { DigitalSolutionsSection } from '@/components/sections/DigitalSolutionsSection';
import { TeamDrivenSection } from '@/components/sections/TeamDrivenSection';
import { IndustryExperienceSection } from '@/components/sections/IndustryExperienceSection';
import { AiInnovationSection } from '@/components/sections/AiInnovationSection';
import { AboutValuesSection } from '@/components/sections/AboutValuesSection';

export default function AboutContent() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero About Section */}
      <AboutHeroSection />

      <TaglineBannerSection contentKey="trusted" />
      
      {/* Team Section with anchor ID */}
      <div id="team">
        <TeamDrivenSection />
      </div>
      
      {/* Values Section with anchor ID */}
      <div id="values">
        <AboutValuesSection anchorId="values" />
      </div>
      
      <TaglineBannerSection contentKey="vision" />
      
      {/* AI Innovation Section with anchor ID */}
      <div id="ai-innovation">
        <AiInnovationSection />
      </div>
      
      {/* Industry Experience Section with anchor ID */}
      <div id="industry-experience">
        <IndustryExperienceSection />
      </div>

      <TaglineBannerSection
        contentKey="at_ciscode"
        showBackground={false}
        showQuotes={true}
        customPadding="py-8 md:py-12"
      />

      {/* Reviews Section with anchor ID */}
      <div id="reviews">
        <ClientsReviewsSectionV2 />
      </div>
      
      <DigitalSolutionsSection anchorId="solutions" />

      {/* Ask Questions Section with anchor ID */}
      <div id="ask-questions">
        <AskQuestionSection />
      </div>
    </div>
  );
}